import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LanguageContext = createContext(null);

const translations = {
  es: {
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Empleados',
    projects: 'Proyectos',
    tasks: 'Tareas',
    timeTracking: 'Control de Horas',
    payments: 'Pagos',
    clients: 'Clientes',
    invoices: 'Facturación',
    quotations: 'Cotizaciones',
    services: 'Servicios',
    quotationRequests: 'Solicitudes',
    capacityPlanning: 'Capacidad',
    subscriptions: 'Transacciones recurrentes',
    timesheetApproval: 'Aprobación Horas',
    billingDashboard: 'Overview',
    auditLog: 'Bitácora',
    vacations: 'Vacaciones',
    suppliers: 'Proveedores',
    crm: 'CRM',
    workflows: 'Workflows',
    companies: 'Empresas',
    users: 'Usuarios',
    accounting: 'Contabilidad',
    stakeholders: 'Stakeholders',
    reports: 'Reportes',
    bank: 'Banca',
    clientPortal: 'Portal Clientes',
    marketplace: 'Marketplace',
    // IT Operations
    itDashboard: 'IT Dashboard',
    itAssets: 'Activos IT',
    itVisits: 'Visitas Técnicas',
    itLocations: 'Ubicaciones',
    itTickets: 'Tickets / Mesa de Ayuda',
    itMaintenance: 'Mantenimiento',
    itContracts: 'Contratos SLA',
    itSpareParts: 'Repuestos',
    itReports: 'Reportes IT',
    invoiceReminders: 'Recordatorios',
    taxReports: 'Impuestos (ITBMS)',
    notificationPreferences: 'Notificaciones',
    settings: 'Configuración',
    logout: 'Cerrar Sesión',
    // Sidebar groups
    groupHR: 'RRHH',
    groupProjects: 'Proyectos & Operaciones',
    groupSales: 'Comercial',
    groupFinance: 'Finanzas',
    groupIT: 'Operaciones IT',
    groupAdmin: 'Administración',
    
    // Auth
    login: 'Iniciar Sesión',
    contactAdminForAccess: 'Para obtener acceso o cambiar tu contraseña, contacta al administrador.',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    name: 'Nombre',
    newPassword: 'Nueva Contraseña',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    
    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    actions: 'Acciones',
    status: 'Estado',
    date: 'Fecha',
    total: 'Total',
    details: 'Detalles',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    loading: 'Cargando...',
    noData: 'No hay datos',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    all: 'Todos',
    active: 'Activo',
    inactive: 'Inactivo',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    
    // Dashboard
    welcomeBack: 'Bienvenido de nuevo',
    totalEmployees: 'Total Empleados',
    activeProjects: 'Proyectos Activos',
    pendingTasks: 'Tareas Pendientes',
    hoursThisMonth: 'Horas Este Mes',
    pendingApprovals: 'Aprobaciones Pendientes',
    totalInvoiced: 'Total Facturado',
    totalCollected: 'Total Cobrado',
    pendingPayroll: 'Nómina Pendiente',
    accountsReceivable: 'Cuentas por Cobrar',
    recentActivity: 'Actividad Reciente',
    upcomingDeadlines: 'Próximos Vencimientos',
    
    // Employees
    newEmployee: 'Nuevo Empleado',
    employeeProfile: 'Perfil del Empleado',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    address: 'Dirección',
    documentId: 'Cédula/Pasaporte',
    position: 'Cargo',
    department: 'Área',
    supervisor: 'Supervisor',
    hireDate: 'Fecha de Ingreso',
    modality: 'Modalidad',
    paymentType: 'Tipo de Pago',
    level: 'Nivel',
    skills: 'Habilidades',
    technologies: 'Tecnologías',
    weeklyCapacity: 'Capacidad Semanal',
    internalCost: 'Costo Interno',
    hourlyRate: 'Tarifa por Hora',
    bankInfo: 'Información Bancaria',
    
    // Modalities
    fullTime: 'Tiempo Completo',
    partTime: 'Medio Tiempo',
    contractor: 'Contratista',
    freelancer: 'Freelancer',
    
    // Payment Types
    fixedSalary: 'Salario Fijo',
    hourlyPayment: 'Pago por Hora',
    taskPayment: 'Pago por Tarea',
    hybrid: 'Híbrido',
    
    // Levels
    junior: 'Junior',
    semiSenior: 'Semi Senior',
    senior: 'Senior',
    
    // Projects
    newProject: 'Nuevo Proyecto',
    projectDetails: 'Detalles del Proyecto',
    projectName: 'Nombre del Proyecto',
    description: 'Descripción',
    client: 'Cliente',
    projectType: 'Tipo de Proyecto',
    manager: 'Responsable',
    team: 'Equipo',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Entrega',
    budget: 'Presupuesto',
    estimatedHours: 'Horas Estimadas',
    priority: 'Prioridad',
    progress: 'Progreso',
    
    // Project Types
    development: 'Desarrollo',
    maintenance: 'Mantenimiento',
    support: 'Soporte',
    internal: 'Interno',
    
    // Project Status
    planning: 'Planeación',
    inProgress: 'En Progreso',
    paused: 'En Pausa',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
    
    // Tasks
    newTask: 'Nueva Tarea',
    taskDetails: 'Detalles de la Tarea',
    taskTitle: 'Título',
    taskType: 'Tipo de Tarea',
    complexity: 'Complejidad',
    storyPoints: 'Puntos',
    deadline: 'Fecha Límite',
    requiredSkills: 'Skills Requeridas',
    assignedTo: 'Asignado a',
    price: 'Precio',
    isMarketplace: 'Marketplace',
    checklist: 'Checklist',
    acceptanceCriteria: 'Criterios de Aceptación',
    takeTask: 'Tomar Tarea',
    submitTask: 'Entregar Tarea',
    approveTask: 'Aprobar Tarea',
    rejectTask: 'Rechazar Tarea',
    
    // Task Types
    coding: 'Desarrollo',
    bugfix: 'Corrección',
    qa: 'QA',
    design: 'Diseño',
    analysis: 'Análisis',
    documentation: 'Documentación',
    
    // Task Status
    available: 'Disponible',
    taken: 'Tomada',
    inReview: 'En Revisión',
    delivered: 'Entregada',
    paid: 'Pagada',
    
    // Priority
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    critical: 'Crítica',
    
    // Complexity
    lowComplexity: 'Baja',
    mediumComplexity: 'Media',
    highComplexity: 'Alta',
    expert: 'Experta',
    
    // Time Tracking
    startTimer: 'Iniciar Timer',
    stopTimer: 'Detener Timer',
    pauseTimer: 'Pausar Timer',
    manualEntry: 'Registro Manual',
    timeEntry: 'Registro de Horas',
    hours: 'Horas',
    billable: 'Facturable',
    nonBillable: 'No Facturable',
    overtime: 'Hora Extra',
    approveHours: 'Aprobar Horas',
    rejectHours: 'Rechazar Horas',
    
    // Payments
    payroll: 'Nómina',
    calculatePayroll: 'Calcular Nómina',
    baseSalary: 'Salario Base',
    hoursPayment: 'Pago por Horas',
    tasksPayment: 'Pago por Tareas',
    bonuses: 'Bonos',
    deductions: 'Deducciones',
    netTotal: 'Total Neto',
    periodStart: 'Inicio del Período',
    periodEnd: 'Fin del Período',
    markAsPaid: 'Marcar como Pagado',
    
    // Clients
    newClient: 'Nuevo Cliente',
    clientDetails: 'Detalles del Cliente',
    contactName: 'Nombre de Contacto',
    taxId: 'RUC',
    paymentTerms: 'Términos de Pago',
    notes: 'Notas',
    
    // Invoices
    newInvoice: 'Nueva Factura',
    invoiceDetails: 'Detalles de la Factura',
    invoiceNumber: 'Número de Factura',
    issueDate: 'Fecha de Emisión',
    dueDate: 'Fecha de Vencimiento',
    subtotal: 'Subtotal',
    taxRate: 'Tasa de Impuesto',
    taxAmount: 'Monto de Impuesto',
    draft: 'Borrador',
    issued: 'Emitida',
    overdue: 'Vencida',
    
    // Marketplace
    availableTasks: 'Tareas Disponibles',
    myTasks: 'Mis Tareas',
    filterBySkill: 'Filtrar por Skill',
    filterByComplexity: 'Filtrar por Complejidad',
    sortByPrice: 'Ordenar por Precio',
    sortByDeadline: 'Ordenar por Fecha',
    
    // Roles
    admin: 'Administrador',
    management: 'Gerencia',
    projectManager: 'Project Manager',
    hr: 'RRHH',
    employee: 'Colaborador',
    clientRole: 'Cliente',
    
    // Messages
    successSaved: 'Guardado exitosamente',
    successDeleted: 'Eliminado exitosamente',
    successApproved: 'Aprobado exitosamente',
    successRejected: 'Rechazado exitosamente',
    errorOccurred: 'Ocurrió un error',
    confirmDelete: '¿Estás seguro de eliminar?',
    
    // KPIs
    completedTasks: 'Tareas Completadas',
    rejectedTasks: 'Tareas Rechazadas',
    productivity: 'Productividad',
    quality: 'Calidad',
    utilization: 'Utilización',
    margin: 'Margen',
    profitability: 'Rentabilidad',
    deviation: 'Desviación',

    // Quotations
    searchQuotations: 'Buscar cotizaciones...',
    newQuotation: 'Nueva Cotización',
    quotationNumber: 'Número',
    validUntil: 'Vigencia',
    clientRequired: 'Cliente *',
    projectOptional: 'Proyecto (opcional)',
    noProject: 'Sin proyecto',
    selectClient: 'Seleccionar cliente',
    selectProject: 'Seleccionar proyecto',
    productsServices: 'Productos/Servicios',
    addItem: 'Agregar',
    serviceDescription: 'Descripción del servicio/producto',
    qty: 'Cant.',
    unitPrice: 'Precio',
    itbmsLabel: 'ITBMS (%)',
    totalUSD: 'Total USD',
    validityDays: 'Validez (días)',
    deliveryTime: 'Tiempo de Entrega',
    deliveryTimePlaceholder: 'Ej: 15 días hábiles',
    paymentMethod: 'Forma de Pago',
    warranty: 'Garantía',
    warrantyPlaceholder: 'Ej: 6 meses de garantía en desarrollo',
    additionalNotes: 'Notas Adicionales',
    saveQuotation: 'Guardar Cotización',
    noQuotations: 'No hay cotizaciones',
    quotationTitle: 'COTIZACIÓN',
    dateLabel: 'Fecha',
    clientLabel: 'Cliente:',
    descriptionCol: 'Descripción',
    print: 'Imprimir',
    exportPdf: 'Exportar PDF',
    markAsSent: 'Marcar como Enviada',
    accepted: 'Aceptada',
    rejected2: 'Rechazada',
    convertToInvoice: 'Convertir a Factura',
    invoiceCreated: 'Factura creada exitosamente',
    statusUpdated: 'Estado actualizado',
    quotationCreated: 'Cotización creada exitosamente',
    statusDraft: 'Borrador',
    statusSent: 'Enviada',
    statusAccepted: 'Aceptada',
    statusRejected: 'Rechazada',
    statusExpired: 'Vencida',
    statusInvoiced: 'Facturada',

    // Accounting
    income: 'Ingresos',
    expenses: 'Gastos',
    netBalance: 'Balance Neto',
    incomeByCategory: 'Ingresos por Categoría',
    expensesByCategory: 'Gastos por Categoría',
    noIncomeThisMonth: 'Sin ingresos este mes',
    noExpensesThisMonth: 'Sin gastos este mes',
    newEntry: 'Nuevo Registro',
    newAccountingEntry: 'Nuevo Registro Contable',
    incomeTab: 'Ingreso',
    expenseTab: 'Gasto',
    category: 'Categoría',
    selectCategory: 'Seleccionar categoría',
    amount: 'Monto ($)',
    notesOptional: 'Notas (opcional)',
    noRecordsPeriod: 'No hay registros para este período',
    entryCreated: 'Registro creado exitosamente',
    entryDeleted: 'Registro eliminado',
    deleteRecord: '¿Eliminar este registro?',

    // Stakeholders
    monthlyComparison: 'Comparativa Mensual de Stakeholders',
    assignedEmployees: 'empleados asignados',
    productivityLabel: 'Productividad',
    hoursLabel: 'Horas',
    tasksLabel: 'Tareas',
    taskValue: 'Valor Tareas',
    monthTotals: 'Totales del Mes',
    totalHours: 'Horas Totales',
    completedTasksLabel: 'Tareas Completadas',
    totalValue: 'Valor Total',
    noDataPeriod: 'No hay datos para este período',
    revenueDistribution: 'Distribución de Ingresos por Proyecto (35% Empresa / 65% Stakeholders)',
    selectProjectDist: 'Seleccionar proyecto',
    totalReceived: 'Total Recibido',
    companyLabel: 'Empresa',
    stakeholderPool: 'Pool Stakeholders',
    distributionByStakeholder: 'Distribución por Stakeholder (proporcional a horas)',
    hoursWorked: 'horas trabajadas',
    noHoursForDistribution: 'No hay horas registradas para calcular distribución. Asigne empleados a stakeholders y registre horas en este proyecto.',
    noPaymentsProject: 'No hay pagos registrados para este proyecto.',
    selectProjectToSee: 'Seleccione un proyecto para ver la distribución de ingresos',
    stakeholderManagement: 'Gestión de Stakeholders',
    newStakeholder: 'Nuevo Stakeholder',
    editStakeholder: 'Editar',
    deleteStakeholder: '¿Eliminar este stakeholder?',
    phone2: 'Teléfono',
    assignedEmployeesLabel: 'Empleados Asignados',
    noEmployeesAvailable: 'No hay empleados disponibles',
    activeLabel: 'Activo',
    inactiveLabel: 'Inactivo',
    noStakeholders: 'No hay stakeholders registrados',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Employees',
    projects: 'Projects',
    tasks: 'Tasks',
    timeTracking: 'Time Tracking',
    payments: 'Payments',
    clients: 'Clients',
    invoices: 'Invoices',
    quotations: 'Quotations',
    services: 'Services',
    quotationRequests: 'Requests',
    capacityPlanning: 'Capacity',
    subscriptions: 'Recurring transactions',
    timesheetApproval: 'Timesheet Approval',
    billingDashboard: 'Overview',
    auditLog: 'Audit Log',
    vacations: 'Vacations',
    suppliers: 'Suppliers',
    crm: 'CRM',
    workflows: 'Workflows',
    companies: 'Companies',
    users: 'Users',
    accounting: 'Accounting',
    stakeholders: 'Stakeholders',
    reports: 'Reports',
    bank: 'Banking',
    clientPortal: 'Client Portal',
    marketplace: 'Marketplace',
    // IT Operations
    itDashboard: 'IT Dashboard',
    itAssets: 'IT Assets',
    itVisits: 'Service Visits',
    itLocations: 'Locations',
    itTickets: 'Tickets / Help Desk',
    itMaintenance: 'Maintenance',
    itContracts: 'SLA Contracts',
    itSpareParts: 'Spare Parts',
    itReports: 'IT Reports',
    invoiceReminders: 'Reminders',
    taxReports: 'Taxes (ITBMS)',
    notificationPreferences: 'Notifications',
    settings: 'Settings',
    logout: 'Logout',
    // Sidebar groups
    groupHR: 'HR',
    groupProjects: 'Projects & Operations',
    groupSales: 'Sales',
    groupFinance: 'Finance',
    groupIT: 'IT Operations',
    groupAdmin: 'Administration',
    
    // Auth
    login: 'Login',
    contactAdminForAccess: 'To get access or change your password, contact the administrator.',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    newPassword: 'New Password',
    alreadyHaveAccount: 'Already have an account?',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    total: 'Total',
    details: 'Details',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    
    // Dashboard
    welcomeBack: 'Welcome back',
    totalEmployees: 'Total Employees',
    activeProjects: 'Active Projects',
    pendingTasks: 'Pending Tasks',
    hoursThisMonth: 'Hours This Month',
    pendingApprovals: 'Pending Approvals',
    totalInvoiced: 'Total Invoiced',
    totalCollected: 'Total Collected',
    pendingPayroll: 'Pending Payroll',
    accountsReceivable: 'Accounts Receivable',
    recentActivity: 'Recent Activity',
    upcomingDeadlines: 'Upcoming Deadlines',
    
    // Employees
    newEmployee: 'New Employee',
    employeeProfile: 'Employee Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    address: 'Address',
    documentId: 'ID/Passport',
    position: 'Position',
    department: 'Department',
    supervisor: 'Supervisor',
    hireDate: 'Hire Date',
    modality: 'Modality',
    paymentType: 'Payment Type',
    level: 'Level',
    skills: 'Skills',
    technologies: 'Technologies',
    weeklyCapacity: 'Weekly Capacity',
    internalCost: 'Internal Cost',
    hourlyRate: 'Hourly Rate',
    bankInfo: 'Bank Information',
    
    // Modalities
    fullTime: 'Full Time',
    partTime: 'Part Time',
    contractor: 'Contractor',
    freelancer: 'Freelancer',
    
    // Payment Types
    fixedSalary: 'Fixed Salary',
    hourlyPayment: 'Hourly Payment',
    taskPayment: 'Task Payment',
    hybrid: 'Hybrid',
    
    // Levels
    junior: 'Junior',
    semiSenior: 'Semi Senior',
    senior: 'Senior',
    
    // Projects
    newProject: 'New Project',
    projectDetails: 'Project Details',
    projectName: 'Project Name',
    description: 'Description',
    client: 'Client',
    projectType: 'Project Type',
    manager: 'Manager',
    team: 'Team',
    startDate: 'Start Date',
    endDate: 'End Date',
    budget: 'Budget',
    estimatedHours: 'Estimated Hours',
    priority: 'Priority',
    progress: 'Progress',
    
    // Project Types
    development: 'Development',
    maintenance: 'Maintenance',
    support: 'Support',
    internal: 'Internal',
    
    // Project Status
    planning: 'Planning',
    inProgress: 'In Progress',
    paused: 'Paused',
    closed: 'Closed',
    cancelled: 'Cancelled',
    
    // Tasks
    newTask: 'New Task',
    taskDetails: 'Task Details',
    taskTitle: 'Title',
    taskType: 'Task Type',
    complexity: 'Complexity',
    storyPoints: 'Story Points',
    deadline: 'Deadline',
    requiredSkills: 'Required Skills',
    assignedTo: 'Assigned To',
    price: 'Price',
    isMarketplace: 'Marketplace',
    checklist: 'Checklist',
    acceptanceCriteria: 'Acceptance Criteria',
    takeTask: 'Take Task',
    submitTask: 'Submit Task',
    approveTask: 'Approve Task',
    rejectTask: 'Reject Task',
    
    // Task Types
    coding: 'Development',
    bugfix: 'Bug Fix',
    qa: 'QA',
    design: 'Design',
    analysis: 'Analysis',
    documentation: 'Documentation',
    
    // Task Status
    available: 'Available',
    taken: 'Taken',
    inReview: 'In Review',
    delivered: 'Delivered',
    paid: 'Paid',
    
    // Priority
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
    
    // Complexity
    lowComplexity: 'Low',
    mediumComplexity: 'Medium',
    highComplexity: 'High',
    expert: 'Expert',
    
    // Time Tracking
    startTimer: 'Start Timer',
    stopTimer: 'Stop Timer',
    pauseTimer: 'Pause Timer',
    manualEntry: 'Manual Entry',
    timeEntry: 'Time Entry',
    hours: 'Hours',
    billable: 'Billable',
    nonBillable: 'Non-Billable',
    overtime: 'Overtime',
    approveHours: 'Approve Hours',
    rejectHours: 'Reject Hours',
    
    // Payments
    payroll: 'Payroll',
    calculatePayroll: 'Calculate Payroll',
    baseSalary: 'Base Salary',
    hoursPayment: 'Hours Payment',
    tasksPayment: 'Tasks Payment',
    bonuses: 'Bonuses',
    deductions: 'Deductions',
    netTotal: 'Net Total',
    periodStart: 'Period Start',
    periodEnd: 'Period End',
    markAsPaid: 'Mark as Paid',
    
    // Clients
    newClient: 'New Client',
    clientDetails: 'Client Details',
    contactName: 'Contact Name',
    taxId: 'RUC',
    paymentTerms: 'Payment Terms',
    notes: 'Notes',
    
    // Invoices
    newInvoice: 'New Invoice',
    invoiceDetails: 'Invoice Details',
    invoiceNumber: 'Invoice Number',
    issueDate: 'Issue Date',
    dueDate: 'Due Date',
    subtotal: 'Subtotal',
    taxRate: 'Tax Rate',
    taxAmount: 'Tax Amount',
    draft: 'Draft',
    issued: 'Issued',
    overdue: 'Overdue',
    
    // Marketplace
    availableTasks: 'Available Tasks',
    myTasks: 'My Tasks',
    filterBySkill: 'Filter by Skill',
    filterByComplexity: 'Filter by Complexity',
    sortByPrice: 'Sort by Price',
    sortByDeadline: 'Sort by Deadline',
    
    // Roles
    admin: 'Administrator',
    management: 'Management',
    projectManager: 'Project Manager',
    hr: 'HR',
    employee: 'Employee',
    clientRole: 'Client',
    
    // Messages
    successSaved: 'Saved successfully',
    successDeleted: 'Deleted successfully',
    successApproved: 'Approved successfully',
    successRejected: 'Rejected successfully',
    errorOccurred: 'An error occurred',
    confirmDelete: 'Are you sure you want to delete?',
    
    // KPIs
    completedTasks: 'Completed Tasks',
    rejectedTasks: 'Rejected Tasks',
    productivity: 'Productivity',
    quality: 'Quality',
    utilization: 'Utilization',
    margin: 'Margin',
    profitability: 'Profitability',
    deviation: 'Deviation',

    // Quotations
    searchQuotations: 'Search quotations...',
    newQuotation: 'New Quotation',
    quotationNumber: 'Number',
    validUntil: 'Valid Until',
    clientRequired: 'Client *',
    projectOptional: 'Project (optional)',
    noProject: 'No project',
    selectClient: 'Select client',
    selectProject: 'Select project',
    productsServices: 'Products/Services',
    addItem: 'Add',
    serviceDescription: 'Service/product description',
    qty: 'Qty.',
    unitPrice: 'Price',
    itbmsLabel: 'ITBMS (%)',
    totalUSD: 'Total USD',
    validityDays: 'Validity (days)',
    deliveryTime: 'Delivery Time',
    deliveryTimePlaceholder: 'e.g. 15 business days',
    paymentMethod: 'Payment Method',
    warranty: 'Warranty',
    warrantyPlaceholder: 'e.g. 6 months dev warranty',
    additionalNotes: 'Additional Notes',
    saveQuotation: 'Save Quotation',
    noQuotations: 'No quotations',
    quotationTitle: 'QUOTATION',
    dateLabel: 'Date',
    clientLabel: 'Client:',
    descriptionCol: 'Description',
    print: 'Print',
    exportPdf: 'Export PDF',
    markAsSent: 'Mark as Sent',
    accepted: 'Accepted',
    rejected2: 'Rejected',
    convertToInvoice: 'Convert to Invoice',
    invoiceCreated: 'Invoice created successfully',
    statusUpdated: 'Status updated',
    quotationCreated: 'Quotation created successfully',
    statusDraft: 'Draft',
    statusSent: 'Sent',
    statusAccepted: 'Accepted',
    statusRejected: 'Rejected',
    statusExpired: 'Expired',
    statusInvoiced: 'Invoiced',

    // Accounting
    income: 'Income',
    expenses: 'Expenses',
    netBalance: 'Net Balance',
    incomeByCategory: 'Income by Category',
    expensesByCategory: 'Expenses by Category',
    noIncomeThisMonth: 'No income this month',
    noExpensesThisMonth: 'No expenses this month',
    newEntry: 'New Entry',
    newAccountingEntry: 'New Accounting Entry',
    incomeTab: 'Income',
    expenseTab: 'Expense',
    category: 'Category',
    selectCategory: 'Select category',
    amount: 'Amount ($)',
    notesOptional: 'Notes (optional)',
    noRecordsPeriod: 'No records for this period',
    entryCreated: 'Entry created successfully',
    entryDeleted: 'Entry deleted',
    deleteRecord: 'Delete this record?',

    // Stakeholders
    monthlyComparison: 'Monthly Stakeholder Comparison',
    assignedEmployees: 'assigned employees',
    productivityLabel: 'Productivity',
    hoursLabel: 'Hours',
    tasksLabel: 'Tasks',
    taskValue: 'Task Value',
    monthTotals: 'Monthly Totals',
    totalHours: 'Total Hours',
    completedTasksLabel: 'Completed Tasks',
    totalValue: 'Total Value',
    noDataPeriod: 'No data for this period',
    revenueDistribution: 'Revenue Distribution by Project (35% Company / 65% Stakeholders)',
    selectProjectDist: 'Select project',
    totalReceived: 'Total Received',
    companyLabel: 'Company',
    stakeholderPool: 'Stakeholder Pool',
    distributionByStakeholder: 'Distribution by Stakeholder (proportional to hours)',
    hoursWorked: 'hours worked',
    noHoursForDistribution: 'No hours recorded for distribution calculation. Assign employees to stakeholders and log hours on this project.',
    noPaymentsProject: 'No payments recorded for this project.',
    selectProjectToSee: 'Select a project to view revenue distribution',
    stakeholderManagement: 'Stakeholder Management',
    newStakeholder: 'New Stakeholder',
    editStakeholder: 'Edit',
    deleteStakeholder: 'Delete this stakeholder?',
    phone2: 'Phone',
    assignedEmployeesLabel: 'Assigned Employees',
    noEmployeesAvailable: 'No employees available',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    noStakeholders: 'No stakeholders registered',
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('valhalla-language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('valhalla-language', language);
  }, [language]);

  const t = useCallback((key) => {
    return translations[language][key] || key;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  }, []);

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isSpanish: language === 'es',
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
